export function showGenderRow(statement) {
    const $statement = $(statement);

    $statement.find('.statements-item-edit-respondent')
        .removeClass('hide');
    $statement.find('[data-respondent-gender-sensitive-checkbox]')
        .attr('checked', 'checked');

    return statement;
}
